import { Star, Quote } from "lucide-react";

export default function TestimonialCard({ testimonial, index }) {
  const { name, company, role, content, rating, service } = testimonial;
  const isEven = index % 2 === 0;

  return (
    <div
      data-testid={`testimonial-card-${index}`}
      className={`bg-[#111111] border border-white/10 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${
        isEven ? "hover:border-pink-500/50 hover:shadow-[0_0_30px_rgba(248,24,148,0.1)]" : "hover:border-purple-500/50 hover:shadow-[0_0_30px_rgba(30,144,255,0.1)]"
      }`}
    >
      {/* Quote Icon */}
      <div className={`w-10 h-10 rounded-full ${isEven ? "bg-gradient-to-r from-purple-500 to-pink-500/10" : "bg-gradient-to-r from-blue-500 to-purple-500/10"} flex items-center justify-center mb-4`}>
        <Quote className={`w-5 h-5 ${isEven ? "text-pink-400" : "text-purple-400"}`} />
      </div>

      {/* Rating */}
      <div className="flex items-center gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`w-4 h-4 ${
              i < rating ? (isEven ? "text-pink-400 fill-pink-400" : "text-purple-400 fill-purple-400") : "text-white/20"
            }`}
          />
        ))}
      </div>

      {/* Content */}
      <p className="text-white/70 text-sm leading-relaxed mb-6">
        "{content}"
      </p>

      {/* Author */}
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className={`w-12 h-12 rounded-full ${isEven ? "bg-gradient-to-r from-purple-500 to-pink-500/20" : "bg-gradient-to-r from-blue-500 to-purple-500/20"} flex items-center justify-center font-heading font-bold text-lg ${isEven ? "text-pink-400" : "text-purple-400"}`}>
          {name.charAt(0)}
        </div>

        <div className="flex-1">
          <h4 className="font-heading font-semibold text-sm text-white">{name}</h4>
          <p className="text-white/50 text-xs">{role}</p>
        </div>
      </div>

      {/* Service Tag */}
      <div className="mt-4 pt-4 border-t border-white/10">
        <span className={`inline-block px-3 py-1 rounded-full ${isEven ? "bg-gradient-to-r from-purple-500 to-pink-500/10 text-pink-400" : "bg-gradient-to-r from-blue-500 to-purple-500/10 text-purple-400"} text-xs font-medium`}>
          {service}
        </span>
      </div>
    </div>
  );
}
